import React, { useState } from 'react';
import fr from 'facet-rest';
import {
  FDStack, FDPaper, FDBodyText,
} from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import FileUploadButtonRebranded from 'Components/ComponentLibrary/Components/Uncategorized/FileUploadButtonRebranded';
import { AttachmentsList } from 'Organisms/AttachmentsList/AttachmentsList';
import { useSnackbarContext } from 'Context/SnackbarContext';

export const CondensedUploader = ({ attachmentGroup }) => {
  const { refreshModalCollection } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();
  const [uploadProgress, setUploadProgress] = useState(null);

  const onFileUploadSuccess = async () => {
    await refreshModalCollection();
  };

  const attachments = attachmentGroup.attr('files').resources().list();

  return attachmentGroup.withRelationship(
    fr.relationships.uploadFile.name,
    (uploadRel) => (
      <FDPaper appearance={'flat'}>
        <FDStack direction={'column'} paddingY={2} spacing={2}>
          <FDStack direction={'column'} spacing={1} paddingX={2}>
            <FDBodyText value={attachmentGroup.attr('prompt')} size={'lg'} alignSelf={'flex-start'} />
            <FileUploadButtonRebranded
              attachmentCollection={attachmentGroup.attr('files')}
              onStart={() => uploadRel.link('related').url()}
              onSuccess={() => onFileUploadSuccess()}
              onFailure={(e) => displayErrorMessage(e, 'Failed to upload file')}
              uploadProgress={uploadProgress}
              setUploadProgress={setUploadProgress}
              buttonLabel={'Upload return'}
              icon={'circle'}
              accept={'image/*,.pdf'}
              test={'upload-btn'}
            />
          </FDStack>
          {attachments.length > 0 && (
          <FDStack direction={'column'} spacing={1} paddingX={2}>
            <AttachmentsList
              attachments={attachments}
              uploadProgress={uploadProgress}
              onDelete={refreshModalCollection}
              uploading={uploadProgress !== null}
            />
          </FDStack>
          )}
        </FDStack>
      </FDPaper>), () => null,
  );
};
